import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable()
export class ApiService {
  url: String = environment.url;
  user: any;
  notificationSubject = new Subject();
  sidebar = false;
  suggestionSubject = new Subject();
  constructor(private http: HttpClient) { }


  setSidebar(){
    this.sidebar = !this.sidebar;
  }

  setUser(user) {
    this.user = user;
  }

  getUser() {
    this.http.get(this.url + '/api/user/get-user').subscribe((res: any) => {
      this.user = res.data;
    });
  }

  login(data) {
    return this.http.post(this.url + '/api/auth/login', data);
  }

  signUp(data) {
    return this.http.post(this.url + '/api/auth/signup', data);
  }

  getProfiles() {
    return this.http.get(this.url + '/api/main-profile/0/0');
  }

  updateUser(data) {
    return this.http.post(this.url + '/api/user/update', data);
  }

  getAllGroups() {
    return this.http.get(this.url + '/api/groups/0/0');
  }

  getgroupById(id) {
    return this.http.get(this.url + '/api/groups/' + id);
  }

  getGoals() {
    return this.http.get(this.url + '/api/goals/0/0');
  }

  getOutcomes() {
    return this.http.get(this.url + '/api/outcome/0/0');
  }

  getActivities() {
    return this.http.get(this.url + '/api/activity/0/0');
  }

  assignGroup(data) {
    return this.http.post(this.url + '/api/user/assign-group', data);
  }

  deAssignGroup(data) {
    return this.http.post(this.url + '/api/user/unjoin-group', data);
  }

  checkMail(data) {
    return this.http.post(this.url + '/api/user/check-mail', data);
  }

  getCategories() {
    return this.http.get(this.url + '/api/profile/0/0/');
  }

  getCreatedCategories(id, all = '') {
    return this.http.get(this.url + '/api/profile/0/0/' + id + '/' + all);
  }

  getCategoryById(id, user) {
    return this.http.post(this.url + '/api/profile/' + user + '/' + id, {});
  }

  getCreatedCategoryById(id, user) {
    return this.http.post(this.url + '/api/profile/' + user + '/' + id + '/all', {});
  }

  getProfileById(id, user, all = false) {
    return this.http.post(this.url + '/api/main-profile/' + user + '/' + id, { all: all });
  }

  getChallenges(id) {
    return this.http.get(this.url + '/api/challenge/0/0/' + id);
  }

  getArchivedChallenges(id) {
    return this.http.get(this.url + '/api/challenge/get/' + id);
  }

  getRecievedChallenges(id) {
    return this.http.post(this.url + '/api/participant/recieved', { id: id });
  }

  createChallenge(data) {
    return this.http.post(this.url + '/api/challenge', data);
  }

  invitePartcipants(data) {
    return this.http.post(this.url + '/api/participant', data);
  }

  filterUsers(search) {
    return this.http.get(this.url + '/api/user/filter/user/' + search);
  }

  getAllUsers() {
    return this.http.get(this.url + '/api/user/0/0');
  }

  forgotPassword(email) {
    return this.http.get(this.url + '/api/auth/' + email);
  }

  updateChallenge(body) {
    return this.http.post(this.url + '/api/challenge/update', body);
  }

  getChallengeByGroup(id) {
    return this.http.get(this.url + '/api/challenge/' + id);
  }

  getChallengeById(body) {
    return this.http.post(this.url + '/api/challenge/get-by-id', body);
  }

  getAllParticipants(id) {
    return this.http.get(this.url + '/api/participant/0/0/' + id);
  }

  getAllcomments(id) {
    return this.http.get(this.url + '/api/comments/0/0/' + id);
  }

  createComment(body) {
    return this.http.post(this.url + '/api/comments', body);
  }

  getPartcipantStatus(body) {
    return this.http.post(this.url + '/api/participant/get-status', body);
  }

  updateParticipant(body) {
    return this.http.post(this.url + '/api/participant/update', body);
  }

  creatNewGoal(data) {
    return this.http.post(this.url + '/api/goals', data);
  }

  getOperations() {
    return this.http.get(this.url + `/api/operations/0/0`);
  }

  getWhats() {
    return this.http.get(this.url + `/api/outcome-what/0/0`);
  }

  getUnits() {
    return this.http.get(this.url + `/api/outcome-units/0/0`);
  }

  createOutcome(data) {
    return this.http.post(this.url + '/api/outcome', data);
  }

  getOutcomeByUser(id) {
    return this.http.get(this.url + '/api/outcome/' + id);
  }

  getOutcomeByUserPost(id) {
    return this.http.post(this.url + '/api/outcome/get-distinct', { id: id });
  }

  createCompletedChallenge(user_id) {
    return this.http.get(this.url + '/api/participant/' + user_id);
  }

  createActivityLogs(user_id, categories = [], users = []) {
    return this.http.post(this.url + '/api/activity-card/get/' + user_id, { categories: categories, users: users });
  }

  filterActivityLogs(user_id, categories = [], time = [], searchText = '', searchFilter = '') {
    return this.http.post(this.url + '/api/activity-card/filter/' + user_id, { categories: categories, time: time, searchText: searchText, searchFilter: searchFilter });
  }

  createLogs(data) {
    return this.http.post(this.url + '/api/activity-card/create', data);
  }

  getwhatFor() {
    return this.http.get(this.url + '/api/outcome-what/0/0');
  }

  getAllOperations() {
    return this.http.get(this.url + '/api/operations/0/0');
  }

  getPIndex(data) {
    return this.http.post(this.url + '/api/outcome/p-index', data);
  }

  getTimeChartData(data) {
    return this.http.post(this.url + '/api/activity-card/p-index', data);
  }

  markAsReadN(id) {
    return this.http.put(this.url + '/api/notification/' + id, {});
  }

  deleteAllN(id) {
    return this.http.delete(this.url + '/api/notification/' + id);
  }

  getAllN(id) {
    return this.http.get(this.url + '/api/notification/' + id);
  }

  markAsReadS(id) {
    return this.http.put(this.url + '/api/suggestion/' + id, {});
  }

  deleteAllS(id) {
    return this.http.delete(this.url + '/api/suggestion/' + id);
  }

  getAllS(id) {
    return this.http.get(this.url + '/api/suggestion/' + id);
  }

  getUpcomingChallenges(user_id, categories = [], users = []) {
    return this.http.post(this.url + '/api/participant/upcoming/' + user_id, { categories: categories, users: users });
  }

  getroadMapData(data) {
    return this.http.post(this.url + '/api/roadmap', data);
  }

  getGroupActivity(data) {
    return this.http.post(this.url + '/api/activity-card/get-group-activities', data);
  }

  getGroupOutcome(data) {
    return this.http.post(this.url + '/api/activity-card/get-group-outcomes', data);
  }

  updateUserGoals(data) {
    return this.http.post(this.url + '/api/user/add-profile-goals', data);
  }

  getClient() {
    return this.http.get(this.url + '/api/adminuser/get-by-name');
  }

  deleteOutcome(id) {
    return this.http.post(this.url + '/api/outcome/delete', { id: id });
  }

  deleteGoals(id) {
    return this.http.post(this.url + '/api/goals/delete', { id: id });
  }

  updateOutcome(body) {
    return this.http.post(this.url + '/api/outcome/update', body);
  }

  getCheckLists(activity) {
    return this.http.get(this.url + `/api/checklist/${activity}`);
  }

  resetUserData() {
    return this.http.post(this.url + `/api/reset-data`, { id: this.user._id });
  }

}
